import React, { useEffect, useState } from "react";
import { collection, getDocs, query, where } from "firebase/firestore";
import { useAuthState } from "react-firebase-hooks/auth";
import { db, auth } from "../../../firebase";
import { Table, Input, Col, Row } from "antd";
import { SearchOutlined } from "@ant-design/icons";

// Components
import PageHeading from "../../../components/common/PageHeading";
import RightBar from "../../../components/common/RightBar";

// data
import { TenantsRightBar } from "./tenatData";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import dayjs from "dayjs";

function Tenants() {
  const [tenants, setTenants] = useState([]);
  const [properties, setProperties] = useState([]);
  const [filterName, setFilterName] = useState("");
  const [property, setProperty] = useState("");
  const [sortedInfo, setSortedInfo] = useState({});
  const [user, loading] = useAuthState(auth);
  const [companyName, setcompanyName] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const fetchCompanyName = async () => {
    try {
      const usersRef = collection(db, "allUsers");
      const userData = query(usersRef, where("uid", "==", user.uid));
      getDocs(userData)
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const res = doc.data();
            setcompanyName(res.companyName);
          });
        })
        .catch((error) => {
          console.log("Error getting users: ", error);
        });
    } catch (err) {
      console.error(err);
    }
  };
  useEffect(() => {
    fetchCompanyName();
    console.log("company name useEffect");
  }, [user, loading]);

  console.log("company name: ", companyName);

  const navigate = useNavigate();
  const currentDate = dayjs();

  useEffect(() => {
    setIsLoading(true);

    if (companyName) {
      const fetchTenants = async () => {
        try {
          const tenantRef = collection(db, "companies", companyName, "tenants");
          const snapshot = await getDocs(tenantRef);

          const fetchData = snapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));
          setTenants(fetchData);
        } catch (err) {
          console.log(err);
          toast.error("Error while fetching tenants", err);
        } finally {
          setIsLoading(false); // stop loading
        }
      };
      console.log("useEffect in tenants.index");
      fetchTenants();
    }
  }, [companyName]);

  useEffect(() => {
    if (companyName) {
      const fetchProperties = async () => {
        try {
          const propertyRef = collection(
            db,
            "companies",
            companyName,
            "properties"
          );
          const snapshot = await getDocs(propertyRef);

          const fetchData = snapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));
          setProperties(fetchData);
        } catch (err) {
          console.log(err);
          toast.error("Error while fetching data", err);
        }
      };
      console.log("useEffect in tenants.index");
      fetchProperties();
    }
  }, [companyName]);

  const filteredDataSource = tenants.filter(
    (record) =>
      filterName === "" ||
      record.profileInfo.firstName
        ?.toLowerCase()
        .includes(filterName.toLowerCase()) ||
      filterName === "" ||
      property.toLowerCase().includes(filterName.toLowerCase())
  );

  const handleChange = (pagination, filters, sorter) => {
    console.log("Various parameters", pagination, filters, sorter);
    setSortedInfo(sorter);
  };

  const tableHeader = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => a.name.length - b.name.length,
      sortOrder: sortedInfo.columnKey === "name" ? sortedInfo.order : null,
      ellipsis: true,
      render: (_, record) => (
        <span className="onclick-text">
          {record.profileInfo?.firstName} {record.profileInfo?.lastName}
        </span>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      sorter: (a, b) => a.status.length - b.status.length,
      sortOrder: sortedInfo.columnKey === "status" ? sortedInfo.order : null,
      render: (_, record) => {
        const moveInDate = dayjs(record.tenantStatus.moveInDate, "YYYY-MM-DD");
        const moveOutDate = record.tenantStatus.moveOutDate;
        console.log("move in", moveInDate);

        if (
          currentDate.isSame(moveInDate, "day") ||
          currentDate.isBefore(moveInDate, "day")
        ) {
          return <span className="onclick-text">future</span>;
        } else if (moveOutDate && currentDate.isAfter(moveInDate, "day")) {
          return <span className="onclick-text">Past</span>;
        } else {
          return <span className="onclick-text">current</span>;
        }
      },
      ellipsis: true,
    },
    {
      title: "Property",
      dataIndex: "property",
      key: "property",
      render: (_, record) => {
        if (record.propertyId) {
          const propertyData = properties.find((item) => {
            return item.id === record.propertyId;
          });
          const object = propertyData?.propertyNameAddress
            ? propertyData?.propertyNameAddress
            : null;
          setProperty(
            object?.propertyName +
              " - " +
              object?.propertyAddressOne +
              " " +
              object?.city +
              "," +
              object?.state +
              " " +
              object?.zipCode
          );
          return <span>{property}</span>;
        } else {
          return <span>--</span>;
        }
      },
    },
    {
      title: "Unit",
      dataIndex: "unit",
      key: "unit",
    },
    {
      title: "Phone",
      dataIndex: "phone",
      key: "phone",
      render: (_, record) => (
        <span>
          {record.contact.phoneNumbers.length > 1
            ? record.contact.phoneNumbers[0].phoneNumber
            : ""}
        </span>
      ),
    },
  ];
  return (
    <>
      <div>
        <PageHeading heading="Tenants" /> 
        <Row>
          <Col span={24}>
            <Input
              placeholder="Search by name or property"
              suffix={
                <SearchOutlined
                  style={{
                    color: "rgba(0,0,0,.45)",
                  }}
                />
              }
              value={filterName}
              onChange={(e) => setFilterName(e.target.value)}
            />
          </Col>
        </Row>
        <br />
        <Table
          columns={tableHeader}
          dataSource={filteredDataSource}
          onChange={handleChange}
          loading={isLoading} // Set loading prop
          onRow={(record) => {
            return {
              onClick: () =>
                navigate(`/people/tenants/tenant-details/${record.id}`),
            };
          }}
          rowKey={(record) => record.id}
        />
      </div>
      <div className="RightSidebar">
        <RightBar RightBarData={TenantsRightBar} />
      </div>
    </>
  );
}

export default Tenants;
